export const translations = {
  en: {
    app_name: "iSaloon",
    tagline: "Beauty Centers Management System",
    developed_by: "Developed By Maham Diverse Solution",
    login: "Login",
    login_with_google: "Sign in with Google",
    username: "Username",
    password: "Password",
    sign_in: "Sign In",
    invalid_credentials: "Invalid username or password",
    or_divider: "OR",
    logout: "Logout",
    language: "Language",
    arabic: "العربية",
    english: "English",
    // nav
    nav_dashboard: "Dashboard",
    nav_bookings: "Bookings",
    nav_services: "Services",
    nav_packages: "Packages",
    nav_products: "Products",
    nav_categories: "Categories",
    nav_purchases: "Purchases",
    nav_suppliers: "Suppliers",
    nav_customers: "Customers",
    nav_pos: "POS",
    nav_inventory: "Inventory",
    nav_stock_movements: "Stock Movements",
    nav_accounting: "Accounting",
    nav_accounts: "Cash & Bank",
    nav_reports: "Reports",
    nav_users: "Users",
    nav_settings: "Settings",
    // dashboard
    revenue: "Revenue",
    expenses: "Expenses",
    profit: "Profit",
    customers_count: "Customers",
    bookings_today: "Bookings Today",
    low_stock: "Low Stock",
    invoices: "Invoices",
    last_7_days: "Last 7 Days",
    // common
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    name: "Name",
    name_en: "Name (English)",
    name_ar: "Name (Arabic)",
    description: "Description",
    description_en: "Description (English)",
    description_ar: "Description (Arabic)",
    category: "Category",
    price: "Price",
    duration: "Duration (min)",
    stock: "Stock",
    sku: "SKU",
    cost: "Cost",
    phone: "Phone",
    email: "Email",
    date_of_birth: "Date of birth",
    search: "Search...",
    actions: "Actions",
    status: "Status",
    date: "Date",
    time: "Time",
    customer: "Customer",
    service: "Service",
    package: "Package",
    notes: "Notes",
    confirm: "Confirm",
    loading: "Loading...",
    no_data: "No data",
    total: "Total",
    subtotal: "Subtotal",
    discount: "Discount",
    tax: "Tax",
    tax_rate: "Tax rate (%)",
    payment_method: "Payment method",
    cash: "Cash",
    card: "Card",
    invoice_number: "Invoice #",
    send_whatsapp: "Send via WhatsApp",
    add_to_cart: "Add",
    cart: "Cart",
    checkout: "Checkout",
    qty: "Qty",
    pay: "Pay",
    split_pay: "Split Pay",
    booking_invoiced: "Booking invoiced",
    booking_invoiced_locked: "This booking is closed — invoice was created at POS. Status changes are disabled.",
    booking_add_service: "Add service",
    booking_add_package: "Add package",
    booking_line_staff_unassigned: "Unassigned",
    booking_staff_required: "Assign staff to each service line",
    booking_search_service_placeholder: "Search services by name or SKU...",
    booking_search_package_placeholder: "Search packages by name...",
    booking_overdue_title: "Past bookings need attention",
    booking_overdue_help: "Past appointments not invoiced or closed. Mark no-show/cancel, or open to invoice via POS.",
    booking_overdue_empty: "No overdue bookings — all caught up!",
    booking_overdue_go_to_day: "Go to day",
    booking_overdue_open: "Open",
    booking_no_show: "No-show",
    booking_stale_banner: "This appointment date has passed. Cancel or mark no-show, or invoice via POS if the service was delivered.",
    booking_stale_timer_note: "Timer frozen at end of appointment day",
    booking_no_show_confirm_title: "Mark as no-show?",
    booking_no_show_confirm_message: "The customer did not attend. This removes the booking from the overdue list.",
    booking_cancel_confirm_title: "Cancel this booking?",
    booking_cancel_confirm_message: "This closes the booking without creating an invoice.",
    cancel_booking: "Cancel",
    time_spent: "Time spent",
    visit_duration_unavailable: "Time spent not recorded — customer was not checked in on arrival.",
    customer_arrived: "Customer arrived",
    customer_arrived_success: "Customer arrival recorded",
    visit_duration: "Visit duration",
    visit_duration_avg: "Avg. visit",
    employee_performance: "Employee Performance",
    active_service_hours: "Active Service Hours",
    active_service_hours_help: "Measures how long each stylist was actively serving customers. Utilization merges overlaps. Shift duty and idle are shown as averages per duty day — more comparable across staff than period totals.",
    active_service_hours_rota_note: "Shift duty uses each employee's published rota (weekly template + overrides).",
    staff_rota: "Staff Rota",
    staff_rota_help: "Weekly shift templates per employee, with dated overrides for days off, extra shifts, and emergency cover.",
    staff_rota_precedence: "Priority: day override (Staff Rota grid) beats weekly template (Employee → Schedule). Publish marks the week as finalized for staff.",
    rota_warning_not_scheduled: "Staff member is not scheduled on this day.",
    rota_warning_outside_shift: "Booking is outside this staff member's shift",
    rota_revert_template: "Revert to template",
    rota_override_active: "Active day override",
    rota_template_library: "Rota template library",
    rota_template_library_help: "Save reusable weekly schedules and apply them to one or more employees (e.g. new hires with no template).",
    rota_template_new: "New template",
    rota_template_apply: "Apply template",
    rota_template_apply_to: "Apply to employees",
    rota_template_no_templates: "No saved templates yet.",
    rota_template_name: "Template name",
    rota_template_load: "Load from library",
    rota_template_save_library: "Save to library",
    rota_template_only_no_template: "Only without template",
    rota_template_select_all: "Select all",
    rota_template_applied: "Template applied",
    rota_template_deleted: "Template deleted",
    rota_template_created: "Template saved to library",
    shift_duty: "Shift duty",
    shift_duty_avg: "Avg shift / day",
    idle_time_avg: "Avg idle / day",
    duty_days: "Duty days",
    utilization_hours: "Utilization (unique)",
    utilization_hours_desc: "Merged busy time — overlapping sessions count once. Idle is only shown for days with at least one service session.",
    workload_hours: "Workload (stacked)",
    workload_hours_desc: "Sum of all session minutes — concurrent bookings add up. Higher than utilization when serving multiple clients at once.",
    idle_time: "Idle time",
    utilization_pct: "Utilization %",
    overlap_time: "Overlap",
    concurrency_factor: "Concurrency",
    sales_target: "Sales target",
    achievement: "Achievement",
    visit_duration_max: "Longest visit",
    visit_duration_count: "Completed visits",
    in_progress: "In progress",
    waiting: "Waiting",
    waiting_time: "Waiting time",
    in_service: "In service",
    service_started: "Service started",
    service_started_success: "Service started — timer running",
    now_serving: "Now Serving",
    avg_waiting: "Avg. wait",
    avg_service: "Avg. service",
    service_duration: "Service time",
    live_duration: "Live duration",
    missing_arrival: "Paid without check-in",
    refresh: "Refresh",
    loyalty_points: "Loyalty Points",
    membership_tier: "Membership Tier",
    total_spent: "Total Spent",
    membership_card: "Membership Card",
    view_card: "View Card",
    book_now: "Book Now",
    select_service: "Select service",
    select_package: "Select package",
    select_date: "Select date",
    select_time: "Select time slot",
    full: "Full",
    remaining: "Remaining",
    book: "Book",
    book_success: "Booking confirmed!",
    payment_success: "Payment registered successfully!",
    choose_service_or_package: "Choose a service or package",
    your_name: "Your name",
    your_phone: "Your phone number",
    // services in public booking
    hero_title: "Step Into Luxury",
    hero_subtitle: "Book your beauty experience online",
    services_available: "Services",
    packages_available: "Packages",
    // accounting
    add_expense: "Add expense",
    expense_description: "Description",
    amount: "Amount",
    // errors
    required_field: "Required field",
    slot_full: "This slot is full",
    seed_demo: "Load demo data",
    services_count: "Services",
    products_count: "Products",
    packages_count: "Packages",
    upcoming_bookings: "Upcoming Bookings",
    recent_invoices: "Recent Invoices",
    whatsapp_invoice: "WhatsApp Invoice",
    whatsapp_marketing: "Marketing Broadcast",
    marketing_message: "Marketing message",
    send: "Send",
    select_customer: "Select customer",
    walk_in: "Walk-in",
    add_customer: "Add customer",
    active: "Active",
    inactive: "Inactive",
    // Wave C — Money infrastructure
    cash_position: "Cash Position",
    eod_cash_count: "End-of-Day Cash Count",
    payment_methods: "Payment Methods",
    counted_amount: "Counted Amount",
    expected: "Expected",
    counted: "Counted",
    variance: "Variance",
    eod_help: "Type the actual cash counted. Variance is computed against the book balance and any difference is recorded as a clear adjustment.",
    period_filter: "Period filter (purchases/sales)",
    accounts: "Accounts",
    type: "Type",
    card: "Card",
    bank: "Bank Transfer",
    wallet: "Wallet",
    sort_order: "Sort Order",
    default: "Default (auto-selected at POS)",
    capacity: "Capacity",
    slot_config: "Slot Capacity Config",
    day_of_week: "Day of Week",
    specific_date: "Specific Date",
    time_slot: "Time Slot",
    apply: "Apply",
    new_booking: "New Booking",
    filter_by_date: "Filter by date",
    all: "All",
    monday: "Monday", tuesday: "Tuesday", wednesday: "Wednesday",
    thursday: "Thursday", friday: "Friday", saturday: "Saturday", sunday: "Sunday",
    confirmed: "Confirmed", cancelled: "Cancelled", completed: "Completed",
    products_tab: "Products", services_tab: "Services", packages_tab: "Packages",
    loyalty_earned: "Loyalty earned",
    clear_cart: "Clear",
    member: "Member",
    scan_to_verify: "Scan to verify",
    powered_by: "Powered by iSaloon",
    // Categories & Purchases
    category_name: "Category name",
    sale_price: "Sale price",
    regular_price: "Regular price",
    in_use_cannot_delete: "Category in use by some products",
    supplier: "Supplier",
    new_purchase: "New purchase",
    purchase_number: "Purchase #",
    unit_cost: "Unit cost",
    line_total: "Line total",
    avg_cost: "Avg. cost",
    new_avg_cost: "New avg cost",
    save_purchase: "Save purchase",
    select_product: "Select product",
    add_item: "Add item",
    grand_total: "Grand total",
    select_category: "Select category",
    on_sale: "On sale",
    items_count: "Items",
    // Reports & discounts
    line_discount: "Line discount",
    overall_discount: "Overall discount",
    overall_discount_share: "Disc. share",
    effective_unit_cost: "Net unit cost",
    reports_accounts: "Accounts Reports",
    reports_sales: "Sales Reports",
    reports_inventory: "Inventory Reports",
    revenue_report: "Revenue",
    expenses_report: "Expenses",
    profit_loss: "Profit & Loss",
    sales_summary: "Sales Summary",
    top_customers: "Top Customers",
    inventory_snapshot: "Inventory Snapshot",
    period: "Period",
    from_date: "From",
    to_date: "To",
    preset_today: "Today",
    preset_month: "This month",
    preset_prev_month: "Previous month",
    preset_year: "This year",
    preset_prev_year: "Previous year",
    preset_custom: "Custom",
    apply_filter: "Apply",
    average_invoice: "Avg invoice",
    margin: "Margin",
    by_category: "By category",
    by_method: "By method",
    item: "Item",
    qty_sold: "Qty sold",
    amount: "Amount",
    products_in_stock: "Products in stock",
    stock_value_cost: "Stock value (cost)",
    stock_value_retail: "Stock value (retail)",
    all_categories: "All categories",
    search_product: "Search product...",
    save_changes: "Save changes",
    // Excel
    export_excel: "Export Excel",
    import_excel: "Import Excel",
    download_template: "Download template",
    importing: "Importing...",
    imported_count: "imported",
    skipped_count: "skipped",
    // Pro accounting
    cogs: "Cost of Goods Sold",
    gross_profit: "Gross Profit",
    net_profit: "Net Profit",
    operating_expenses: "Operating Expenses",
    gross_margin: "Gross margin",
    net_margin: "Net margin",
    // Inventory movements
    nav_stock_movements: "Stock Movements",
    stock_in: "In",
    stock_out: "Out",
    stock_adjust: "Adjust",
    adjust_stock: "Adjust stock",
    qty_change: "Qty change",
    reason: "Reason",
    movement_log: "Movement log",
    purchase_report: "Purchases",
    purchases_report: "Purchases Report",
    // Accounts
    nav_accounts: "Cash & Bank",
    nav_suppliers: "Suppliers",
    nav_users: "Users",
    nav_branches: "Branches",
    nav_website: "Website CMS",
    nav_coupons: "Coupons",
    nav_reviews: "Reviews",
    nav_commissions: "Commissions",
    nav_staff_payouts: "Staff Payouts",
    tip: "Tip",
    tip_split: "Split tip",
    amount_due: "Amount due",
    commission_pending: "Pending",
    commission_paid: "Paid out",
    commission_owed: "Owed (unpaid)",
    tips_owed: "Tips owed",
    commissions_page_help: "Set commission rules and view sales reports here. Actual amounts owed to staff are paid on Staff Payouts.",
    commissions_go_pay: "Pay staff",
    commissions_owed_title: "Unpaid this period",
    commissions_owed_help: "Matches Staff Payouts for the same dates. Commissions accrue when invoices are posted at POS; tips accrue when tips are recorded.",
    commissions_report_help: "Calculated = sales × rules. Owed = unpaid accruals ready to pay. Paid out = already confirmed on Staff Payouts.",
    tips_report_help: "Tips recorded at POS in this period. Owed tips are paid from Staff Payouts.",
    tips_report_empty: "No tips in this period. If staff are owed tips, check the month matches Staff Payouts.",
    payouts_page_title: "Pay commissions & tips",
    payouts_page_help: "Confirm payouts here to mark accruals as paid and deduct from your cash/bank account. This is separate from salary payroll.",
    payouts_view_reports: "View commission reports",
    confirm_payout: "Confirm payout",
    nav_analytics: "Analytics",
    nav_notifications: "Notifications",
    nav_whatsapp: "WhatsApp",
    nav_employees: "Employees",
    nav_departments: "Departments",
    account_name: "Account name",
    account_kind: "Type",
    cash_account: "Cash",
    bank_account: "Bank",
    opening_balance: "Opening balance",
    current_balance: "Balance",
    default_account: "Default",
    deposit: "Deposit",
    withdraw: "Withdraw",
    transactions: "Transactions",
    view_transactions: "View transactions",
    // Expenses (enhanced)
    one_time: "One-time",
    recurring: "Recurring",
    fixed_expense: "Fixed",
    variable_expense: "Variable",
    start_date: "Start date",
    end_date: "End date",
    from_account: "Deduct from account",
    // POS (loyalty)
    redeem_points: "Redeem points",
    available_points: "Available points",
    points_value: "Points value",
    // Users
    role_admin: "Admin",
    role_staff: "Staff",
    role_manager: "Manager",
    allowed_modules: "Allowed modules",
    // Dashboard
    dashboard_operational: "Operational",
    dashboard_executive: "Executive",
    bookings_week: "Bookings this week",
    invoices_today: "Invoices today",
    invoices_month: "Invoices this month",
    revenue_services: "Services revenue",
    revenue_products: "Products revenue",
    revenue_packages: "Packages revenue",
    cash_flow: "Cash flow",
    new_customers: "New customers",
    trend_6m: "6-month trend",
    // PDF
    export_pdf: "PDF",
    // Suppliers
    address: "Address",
    // === Localization audit P0/P1 additions (Phase A) ===
    // Generic action toasts (used app-wide; replaces hard-coded "Saved"/"Error")
    saved: "Saved",
    error_generic: "Error",
    delete_confirm: "Delete?",
    copy_failed: "Copy failed",
    print_failed: "Print failed",
    load_failed: "Failed to load",
    excel_exported: "Excel exported",
    account_not_selected: "Account not selected",
    // Status badges used in tenant admin & subscriptions screens
    status_active: "Active",
    status_inactive: "Inactive",
    status_pending: "Pending",
    status_approved: "Approved",
    status_completed: "Completed",
    status_cancelled: "Cancelled",
    status_suspended: "Suspended",
    status_expired: "Expired",
    status_archived: "Archived",
    status_paid: "Paid",
    status_unpaid: "Unpaid",
    status_draft: "Draft",
    status_sent: "Sent",
    status_received: "Received",
    status_failed: "Failed",
    status_published: "Published",
    // Onboarding wizard business types
    business_type_beauty_salon: "Beauty Salon",
    business_type_nail_salon: "Nail Salon",
    business_type_massage_center: "Massage Center",
    business_type_wellness_center: "Wellness Center",
    // WhatsApp template categories (platform admin)
    wa_cat_transactional: "Transactional",
    wa_cat_marketing: "Marketing",
    wa_cat_utility: "Utility",
    wa_provider_meta_cloud: "Meta Cloud API",
    // === Backend error mappings (used via lib/errors.js localizeError) ===
    required_field: "Required",
    no_items: "No items",
    invalid_input: "Invalid input",
    phone_required: "Phone number is required",
    customer_phone_not_registered: "Customer phone is not registered",
    message_body_required: "Message body is required",
    product_not_found: "Product not found",
    employee_not_found: "Employee not found",
    customer_not_found: "Customer not found",
    service_not_found: "Service not found",
    package_not_found: "Package not found",
    invoice_not_found: "Invoice not found",
    branch_not_found: "Branch not found",
    account_not_found: "Account not found",
    branch_required: "Branch is required",
    invalid_branch_id: "Invalid branch",
    no_recipients_matched: "No recipients matched the selected segment",
    duplicate_national_id: "An employee with this national ID already exists",
    insufficient_stock: "Insufficient stock",
    invalid_credentials: "Invalid username or password",
    not_authenticated: "Not authenticated",
    forbidden: "Access denied",
    invalid_employee_user_id: "Invalid staff member assignment on one or more items",
    // Statement picker & Accounts modals
    select_statement_period: "Select Statement Period",
    statement_period_help: "Choose the period to print all transactions for. The statement shows an opening balance, all transactions in chronological order with running balance, and a closing balance.",
    period_all: "All periods",
    period_this_month: "This month",
    period_prev_month: "Previous month",
    period_ytd: "Year to date",
    period_year: "This year",
    period_specific_month: "Specific month",
    period_custom: "Custom",
    select_month: "Select month",
    range_from: "From",
    range_to: "To",
    print: "Print",
    linked_account: "Linked cash/bank account",
    no_link_manual: "— No link (manual) —",
    method_target_help: "When this payment method is selected in POS, this account will be auto-selected.",
    default_pos_auto: "Default (auto-selected in POS)",
    account: "Account",
  },
  ar: {
    app_name: "آي صالون",
    tagline: "نظام إدارة مراكز التجميل",
    developed_by: "Developed By Maham Diverse Solution",
    login: "تسجيل الدخول",
    login_with_google: "تسجيل الدخول بجوجل",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    sign_in: "دخول",
    invalid_credentials: "اسم المستخدم أو كلمة المرور غير صحيحة",
    or_divider: "أو",
    logout: "تسجيل الخروج",
    language: "اللغة",
    arabic: "العربية",
    english: "English",
    nav_dashboard: "الرئيسية",
    nav_bookings: "الحجوزات",
    nav_services: "الخدمات",
    nav_packages: "الباقات",
    nav_products: "المنتجات",
    nav_categories: "التصنيفات",
    nav_purchases: "المشتريات",
    nav_customers: "العملاء",
    nav_pos: "نقطة البيع",
    nav_inventory: "المخزون",
    nav_accounting: "الحسابات",
    nav_reports: "التقارير",
    nav_settings: "الإعدادات",
    revenue: "الإيرادات",
    expenses: "المصروفات",
    profit: "الأرباح",
    customers_count: "العملاء",
    bookings_today: "حجوزات اليوم",
    low_stock: "مخزون منخفض",
    invoices: "الفواتير",
    last_7_days: "آخر ٧ أيام",
    add: "إضافة",
    edit: "تعديل",
    delete: "حذف",
    save: "حفظ",
    cancel: "إلغاء",
    name: "الاسم",
    name_en: "الاسم (إنجليزي)",
    name_ar: "الاسم (عربي)",
    description: "الوصف",
    description_en: "الوصف (إنجليزي)",
    description_ar: "الوصف (عربي)",
    category: "التصنيف",
    price: "السعر",
    duration: "المدة (دقيقة)",
    stock: "المخزون",
    sku: "رمز المنتج",
    cost: "التكلفة",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    date_of_birth: "تاريخ الميلاد",
    search: "بحث...",
    actions: "الإجراءات",
    status: "الحالة",
    date: "التاريخ",
    time: "الوقت",
    customer: "العميل",
    service: "الخدمة",
    package: "الباقة",
    notes: "ملاحظات",
    confirm: "تأكيد",
    loading: "جارٍ التحميل...",
    no_data: "لا توجد بيانات",
    total: "الإجمالي",
    subtotal: "المجموع الفرعي",
    discount: "الخصم",
    tax: "الضريبة",
    tax_rate: "نسبة الضريبة (%)",
    payment_method: "طريقة الدفع",
    cash: "نقدي",
    card: "بطاقة",
    invoice_number: "رقم الفاتورة",
    send_whatsapp: "إرسال عبر واتساب",
    add_to_cart: "إضافة",
    cart: "السلة",
    checkout: "إتمام الدفع",
    qty: "الكمية",
    pay: "دفع",
    split_pay: "دفع مقسّم",
    booking_invoiced: "تمت الفوترة",
    booking_invoiced_locked: "هذا الحجز مغلق — تم إنشاء فاتورة من نقطة البيع. لا يمكن تغيير الحالة.",
    booking_add_service: "إضافة خدمة",
    booking_add_package: "إضافة باقة",
    booking_line_staff_unassigned: "غير مُسند",
    booking_staff_required: "عيّن موظفاً لكل سطر خدمة",
    booking_search_service_placeholder: "ابحث عن الخدمات بالاسم أو الرمز...",
    booking_search_package_placeholder: "ابحث عن الباقات بالاسم...",
    booking_overdue_title: "حجوزات سابقة تحتاج متابعة",
    booking_overdue_help: "مواعيد مضت دون فوترة أو إغلاق. سجّل عدم الحضور/الإلغاء، أو افتح للفوترة من نقطة البيع.",
    booking_overdue_empty: "لا توجد حجوزات متأخرة — كل شيء محدّث!",
    booking_overdue_go_to_day: "عرض اليوم",
    booking_overdue_open: "فتح",
    booking_no_show: "لم يحضر",
    booking_stale_banner: "تاريخ هذا الموعد قد مضى. ألغِ أو سجّل عدم الحضور، أو فوّت من نقطة البيع إذا تمت الخدمة.",
    booking_stale_timer_note: "الوقت مجمّد عند نهاية يوم الموعد",
    booking_no_show_confirm_title: "تسجيل عدم الحضور؟",
    booking_no_show_confirm_message: "العميل لم يحضر. سيُزال الحجز من قائمة المتابعة.",
    booking_cancel_confirm_title: "إلغاء هذا الحجز؟",
    booking_cancel_confirm_message: "يُغلق الحجز دون إنشاء فاتورة.",
    cancel_booking: "إلغاء",
    time_spent: "الوقت المستغرق",
    visit_duration_unavailable: "لم يُسجَّل الوقت — لم يتم تسجيل وصول العميل.",
    customer_arrived: "وصول العميل",
    customer_arrived_success: "تم تسجيل وصول العميل",
    visit_duration: "مدة الزيارة",
    visit_duration_avg: "متوسط الزيارة",
    employee_performance: "أداء الموظفين",
    active_service_hours: "ساعات الخدمة النشطة",
    active_service_hours_help: "يقيس مدة انشغال كل موظف بخدمة العملاء. الاستغلال يدمج التداخلات. ساعات الدوام ووقت الفراغ تُعرض كمتوسط يومي — أوضح للمقارنة بين الموظفين من مجاميع الفترة.",
    active_service_hours_rota_note: "ساعات الدوام تُحسب من جدول كل موظف (قالب أسبوعي + تعديلات يومية).",
    staff_rota: "جدول الدوام",
    staff_rota_help: "قالب دوام أسبوعي لكل موظف، مع تعديلات يومية للإجازات والورديات الإضافية والطوارئ.",
    staff_rota_precedence: "الأولوية: التعديل اليومي (جدول الدوام) يتفوق على القالب الأسبوعي (الموظف ← الجدول). النشر يثبت الأسبوع للموظفين.",
    rota_warning_not_scheduled: "الموظف غير مجدول في هذا اليوم.",
    rota_warning_outside_shift: "الحجز خارج دوام هذا الموظف",
    rota_revert_template: "العودة للقالب",
    rota_override_active: "تعديل يومي نشط",
    rota_template_library: "مكتبة قوالب الدوام",
    rota_template_library_help: "احفظ جداول أسبوعية قابلة لإعادة الاستخدام وطبّقها على موظف واحد أو أكثر (مثل الموظفين الجدد بدون قالب).",
    rota_template_new: "قالب جديد",
    rota_template_apply: "تطبيق القالب",
    rota_template_apply_to: "تطبيق على الموظفين",
    rota_template_no_templates: "لا توجد قوالب محفوظة بعد.",
    rota_template_name: "اسم القالب",
    rota_template_load: "تحميل من المكتبة",
    rota_template_save_library: "حفظ في المكتبة",
    rota_template_only_no_template: "بدون قالب فقط",
    rota_template_select_all: "تحديد الكل",
    rota_template_applied: "تم تطبيق القالب",
    rota_template_deleted: "تم حذف القالب",
    rota_template_created: "تم حفظ القالب في المكتبة",
    shift_duty: "ساعات الدوام",
    shift_duty_avg: "متوسط الدوام / يوم",
    idle_time_avg: "متوسط الفراغ / يوم",
    duty_days: "أيام الدوام",
    utilization_hours: "الاستغلال (فريد)",
    utilization_hours_desc: "وقت الانشغال بعد دمج التداخلات — الجلسات المتزامنة تُحسب مرة واحدة. وقت الفراغ يظهر فقط للأيام التي فيها جلسة خدمة واحدة على الأقل.",
    workload_hours: "عبء العمل (متراكم)",
    workload_hours_desc: "مجموع دقائق كل الجلسات — الحجوزات المتزامنة تُجمع. أعلى من الاستغلال عند خدمة أكثر من عميل في آن واحد.",
    idle_time: "وقت الفراغ",
    utilization_pct: "نسبة الاستغلال",
    overlap_time: "التداخل",
    concurrency_factor: "معامل التزامن",
    sales_target: "هدف المبيعات",
    achievement: "الإنجاز",
    visit_duration_max: "أطول زيارة",
    visit_duration_count: "زيارات مكتملة",
    in_progress: "جارية",
    waiting: "انتظار",
    waiting_time: "وقت الانتظار",
    in_service: "قيد الخدمة",
    service_started: "بدء الخدمة",
    service_started_success: "تم بدء الخدمة — المؤقت يعمل",
    now_serving: "قيد الخدمة الآن",
    avg_waiting: "متوسط الانتظار",
    avg_service: "متوسط الخدمة",
    service_duration: "مدة الخدمة",
    live_duration: "المدة الحية",
    missing_arrival: "دفع بدون تسجيل وصول",
    refresh: "تحديث",
    loyalty_points: "نقاط الولاء",
    membership_tier: "فئة العضوية",
    total_spent: "إجمالي الإنفاق",
    membership_card: "بطاقة العضوية",
    view_card: "عرض البطاقة",
    book_now: "احجز الآن",
    select_service: "اختر الخدمة",
    select_package: "اختر الباقة",
    select_date: "اختر التاريخ",
    select_time: "اختر الوقت",
    full: "ممتلئ",
    remaining: "متبقي",
    book: "حجز",
    book_success: "تم تأكيد الحجز!",
    payment_success: "تم تسجيل الدفع بنجاح!",
    choose_service_or_package: "اختر خدمة أو باقة",
    your_name: "اسمك",
    your_phone: "رقم هاتفك",
    hero_title: "ادخلي عالم الفخامة",
    hero_subtitle: "احجزي تجربة الجمال أونلاين",
    services_available: "الخدمات",
    packages_available: "الباقات",
    add_expense: "إضافة مصروف",
    expense_description: "الوصف",
    amount: "المبلغ",
    required_field: "حقل مطلوب",
    slot_full: "هذا الموعد ممتلئ",
    seed_demo: "تحميل بيانات تجريبية",
    services_count: "الخدمات",
    products_count: "المنتجات",
    packages_count: "الباقات",
    upcoming_bookings: "الحجوزات القادمة",
    recent_invoices: "أحدث الفواتير",
    whatsapp_invoice: "فاتورة واتساب",
    whatsapp_marketing: "رسائل تسويقية",
    marketing_message: "الرسالة التسويقية",
    send: "إرسال",
    select_customer: "اختر العميل",
    walk_in: "عميل عابر",
    add_customer: "إضافة عميل",
    active: "نشط",
    inactive: "غير نشط",
    // Wave C — البنية التحتية للمال
    cash_position: "الوضع النقدي",
    eod_cash_count: "جرد آخر اليوم",
    payment_methods: "طرق الدفع",
    counted_amount: "المبلغ المعدود",
    expected: "المتوقع",
    counted: "المعدود",
    variance: "الفرق",
    eod_help: "اكتب المبلغ المعدود فعلياً. سيتم احتساب الفرق تلقائياً ضد رصيد الدفتر، وأي فرق سيُسجَّل كقيد تسوية واضح.",
    period_filter: "فلتر الفترة (مشتريات/مبيعات)",
    accounts: "الحسابات",
    type: "النوع",
    card: "بطاقة",
    bank: "تحويل بنكي",
    wallet: "محفظة",
    sort_order: "الترتيب",
    default: "افتراضي (يُختار تلقائياً في نقطة البيع)",
    capacity: "السعة",
    slot_config: "إعدادات سعة المواعيد",
    day_of_week: "يوم الأسبوع",
    specific_date: "تاريخ محدد",
    time_slot: "وقت الموعد",
    apply: "تطبيق",
    new_booking: "حجز جديد",
    filter_by_date: "تصفية بالتاريخ",
    all: "الكل",
    monday: "الإثنين", tuesday: "الثلاثاء", wednesday: "الأربعاء",
    thursday: "الخميس", friday: "الجمعة", saturday: "السبت", sunday: "الأحد",
    confirmed: "مؤكد", cancelled: "ملغي", completed: "منتهي",
    products_tab: "المنتجات", services_tab: "الخدمات", packages_tab: "الباقات",
    loyalty_earned: "النقاط المكتسبة",
    clear_cart: "مسح",
    member: "عضو",
    scan_to_verify: "امسحي للتحقق",
    powered_by: "مشغل بواسطة آي صالون",
    category_name: "اسم التصنيف",
    sale_price: "سعر العرض",
    regular_price: "السعر الأساسي",
    in_use_cannot_delete: "لا يمكن الحذف - التصنيف مستخدم في منتجات",
    supplier: "المورد",
    new_purchase: "فاتورة شراء جديدة",
    purchase_number: "رقم الفاتورة",
    unit_cost: "تكلفة الوحدة",
    line_total: "إجمالي السطر",
    avg_cost: "متوسط التكلفة",
    new_avg_cost: "متوسط التكلفة الجديد",
    save_purchase: "حفظ الفاتورة",
    select_product: "اختر المنتج",
    add_item: "إضافة صنف",
    grand_total: "الإجمالي",
    select_category: "اختر التصنيف",
    on_sale: "عرض",
    items_count: "الأصناف",
    line_discount: "خصم السطر",
    overall_discount: "خصم إجمالي",
    overall_discount_share: "حصة الخصم",
    effective_unit_cost: "صافي تكلفة الوحدة",
    reports_accounts: "تقارير الحسابات",
    reports_sales: "تقارير المبيعات",
    reports_inventory: "تقارير المخزون",
    revenue_report: "الإيرادات",
    expenses_report: "المصروفات",
    profit_loss: "الأرباح والخسائر",
    sales_summary: "ملخص المبيعات",
    top_customers: "أفضل العملاء",
    inventory_snapshot: "حالة المخزون",
    period: "الفترة",
    from_date: "من",
    to_date: "إلى",
    preset_today: "اليوم",
    preset_month: "هذا الشهر",
    preset_prev_month: "الشهر السابق",
    preset_year: "هذه السنة",
    preset_prev_year: "السنة السابقة",
    preset_custom: "مخصص",
    apply_filter: "تطبيق",
    average_invoice: "متوسط الفاتورة",
    margin: "الهامش",
    by_category: "حسب التصنيف",
    by_method: "حسب طريقة الدفع",
    item: "الصنف",
    qty_sold: "الكمية المباعة",
    amount: "المبلغ",
    products_in_stock: "منتجات في المخزون",
    stock_value_cost: "قيمة المخزون (تكلفة)",
    stock_value_retail: "قيمة المخزون (بيع)",
    all_categories: "جميع التصنيفات",
    search_product: "ابحث عن منتج...",
    save_changes: "حفظ التعديلات",
    export_excel: "تصدير Excel",
    import_excel: "استيراد Excel",
    download_template: "تنزيل قالب",
    importing: "جارٍ الاستيراد...",
    imported_count: "تم استيرادها",
    skipped_count: "تم تجاهلها",
    cogs: "تكلفة البضاعة المباعة",
    gross_profit: "إجمالي الربح",
    net_profit: "صافي الربح",
    operating_expenses: "المصروفات التشغيلية",
    gross_margin: "هامش إجمالي",
    net_margin: "هامش صافي",
    nav_stock_movements: "حركات المخزون",
    stock_in: "وارد",
    stock_out: "صادر",
    stock_adjust: "تسوية",
    adjust_stock: "تعديل المخزون",
    qty_change: "تغيير الكمية",
    reason: "السبب",
    movement_log: "سجل الحركات",
    purchase_report: "المشتريات",
    purchases_report: "تقرير المشتريات",
    nav_accounts: "الصناديق والبنوك",
    nav_suppliers: "الموردون",
    nav_users: "المستخدمون",
    nav_branches: "الفروع",
    nav_website: "إدارة الموقع",
    nav_coupons: "الكوبونات",
    nav_reviews: "التقييمات",
    nav_commissions: "العمولات",
    nav_staff_payouts: "صرف العمولات والإكراميات",
    tip: "إكرامية",
    tip_split: "توزيع الإكرامية",
    amount_due: "المبلغ المستحق",
    commission_pending: "معلق",
    commission_paid: "تم الصرف",
    commission_owed: "مستحق (غير مدفوع)",
    tips_owed: "إكراميات مستحقة",
    commissions_page_help: "اضبط قواعد العمولة واعرض التقارير هنا. المبالغ المستحقة تُصرف من صفحة صرف العمولات والإكراميات.",
    commissions_go_pay: "صرف للموظفين",
    commissions_owed_title: "غير مدفوع في هذه الفترة",
    commissions_owed_help: "يطابق صفحة الصرف لنفس التواريخ. تُسجَّل العمولات عند الفوترة من نقطة البيع؛ والإكراميات عند تسجيلها.",
    commissions_report_help: "المحسوب = مبيعات × القواعد. المستحق = مستحقات غير مدفوعة جاهزة للصرف. تم الصرف = مؤكَّد في صفحة الصرف.",
    tips_report_help: "إكراميات مسجَّلة من نقطة البيع في هذه الفترة. تُصرف من صفحة الصرف.",
    tips_report_empty: "لا إكراميات في هذه الفترة. إن كان هناك مستحقات، تأكد أن الشهر يطابق صفحة الصرف.",
    payouts_page_title: "صرف العمولات والإكراميات",
    payouts_page_help: "أكِّد الصرف هنا لتحديد المستحقات كمدفوعة وخصمها من الصندوق/البنك. منفصل عن رواتب الموظفين.",
    payouts_view_reports: "عرض تقارير العمولات",
    confirm_payout: "تأكيد الصرف",
    nav_analytics: "التحليلات",
    nav_notifications: "الإشعارات",
    nav_whatsapp: "واتساب",
    nav_employees: "الموظفون",
    nav_departments: "الأقسام",
    account_name: "اسم الحساب",
    account_kind: "النوع",
    cash_account: "نقدي",
    bank_account: "بنكي",
    opening_balance: "الرصيد الافتتاحي",
    current_balance: "الرصيد",
    default_account: "افتراضي",
    deposit: "إيداع",
    withdraw: "سحب",
    transactions: "الحركات",
    view_transactions: "عرض الحركات",
    one_time: "مرة واحدة",
    recurring: "متكرر",
    fixed_expense: "ثابت",
    variable_expense: "متغير",
    start_date: "تاريخ البداية",
    end_date: "تاريخ النهاية",
    from_account: "خصم من حساب",
    redeem_points: "استبدال نقاط",
    available_points: "النقاط المتاحة",
    points_value: "قيمة النقاط",
    role_admin: "مدير",
    role_staff: "موظف",
    role_manager: "مدير عام",
    allowed_modules: "الوحدات المسموحة",
    dashboard_operational: "تشغيلي",
    dashboard_executive: "تنفيذي",
    bookings_week: "حجوزات الأسبوع",
    invoices_today: "فواتير اليوم",
    invoices_month: "فواتير الشهر",
    revenue_services: "إيرادات الخدمات",
    revenue_products: "إيرادات المنتجات",
    revenue_packages: "إيرادات الباقات",
    cash_flow: "التدفق النقدي",
    new_customers: "عملاء جدد",
    trend_6m: "٦ أشهر",
    export_pdf: "PDF",
    address: "العنوان",
    // === Localization audit P0/P1 additions (Phase A) ===
    saved: "تم الحفظ",
    error_generic: "حدث خطأ",
    delete_confirm: "هل أنت متأكد من الحذف؟",
    copy_failed: "فشل النسخ",
    print_failed: "فشل الطباعة",
    load_failed: "فشل التحميل",
    excel_exported: "تم تصدير ملف Excel",
    account_not_selected: "لم يتم تحديد الحساب",
    // Status badges
    status_active: "نشط",
    status_inactive: "غير نشط",
    status_pending: "قيد المراجعة",
    status_approved: "معتمد",
    status_completed: "مكتمل",
    status_cancelled: "ملغى",
    status_suspended: "موقوف",
    status_expired: "منتهي",
    status_archived: "مؤرشف",
    status_paid: "مدفوع",
    status_unpaid: "غير مدفوع",
    status_draft: "مسودة",
    status_sent: "مُرسل",
    status_received: "مُستلم",
    status_failed: "فشل",
    status_published: "منشور",
    // Onboarding wizard business types
    business_type_beauty_salon: "صالون تجميل",
    business_type_nail_salon: "صالون أظافر",
    business_type_massage_center: "مركز مساج",
    business_type_wellness_center: "مركز عافية",
    // WhatsApp template categories
    wa_cat_transactional: "معاملات",
    wa_cat_marketing: "تسويق",
    wa_cat_utility: "خدمي",
    wa_provider_meta_cloud: "Meta Cloud API",
    // === Backend error mappings (Arabic) ===
    required_field: "الحقل مطلوب",
    no_items: "لا توجد بنود",
    invalid_input: "بيانات غير صحيحة",
    phone_required: "رقم الجوال مطلوب",
    customer_phone_not_registered: "رقم جوال العميل غير مسجل",
    message_body_required: "نص الرسالة مطلوب",
    product_not_found: "المنتج غير موجود",
    employee_not_found: "الموظف غير موجود",
    customer_not_found: "العميل غير موجود",
    service_not_found: "الخدمة غير موجودة",
    package_not_found: "الباقة غير موجودة",
    invoice_not_found: "الفاتورة غير موجودة",
    branch_not_found: "الفرع غير موجود",
    account_not_found: "الحساب غير موجود",
    branch_required: "الفرع مطلوب",
    invalid_branch_id: "فرع غير صالح",
    no_recipients_matched: "لا يوجد عملاء يطابقون الشريحة المختارة",
    duplicate_national_id: "يوجد موظف برقم الهوية ذاته",
    insufficient_stock: "الكمية غير كافية في المخزون",
    invalid_credentials: "اسم المستخدم أو كلمة المرور غير صحيحة",
    not_authenticated: "غير مُسجل دخول",
    forbidden: "غير مصرح بالوصول",
    invalid_employee_user_id: "موظف غير صالح في بند أو أكثر",
    // Statement picker & Accounts modals
    select_statement_period: "اختر فترة كشف الحساب",
    statement_period_help: "اختر الفترة التي تريد طباعة جميع حركاتها — يعرض الكشف رصيداً افتتاحياً، كل الحركات بترتيب زمني مع الرصيد التراكمي، ورصيداً ختامياً.",
    period_all: "كل الفترات",
    period_this_month: "هذا الشهر",
    period_prev_month: "الشهر السابق",
    period_ytd: "من بداية السنة",
    period_year: "السنة الحالية",
    period_specific_month: "شهر محدد",
    period_custom: "مخصص",
    select_month: "اختر الشهر",
    range_from: "من",
    range_to: "إلى",
    print: "طباعة",
    linked_account: "الصندوق/البنك المرتبط",
    no_link_manual: "— بدون ربط (يدوي) —",
    method_target_help: "عند اختيار طريقة الدفع هذه في نقطة البيع، سيتم تحديد هذا الصندوق تلقائياً.",
    default_pos_auto: "افتراضي (مختار تلقائياً في نقطة البيع)",
    account: "الحساب",
  },
};
